import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'my-tickets', pathMatch: 'full' },
  {
    path: 'my-tickets',
    loadChildren: () =>
      import('./my-tickets/my-tickets.routes').then((c) => c.routes),
  },
  {
    path: 'console',
    loadChildren: () => import('./console/console.routes').then((c) => c.routes),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./notifications/notifications.routes').then((c) => c.routes),
  },
];
